import React from 'react';
import PropTypes from 'prop-types';
import isTransactionComplete from '../../../../shared/helpers/isTransactionComplete';
import {
  getSyndicationProgramSignUpCompletedDate,
  isWithinSyndicationProgramWaitingPeriod,
  isUserEligibleToInvestInSyndication,
} from '../../../../shared/helpers/syndicationProgramHelpers';

const TopbarNavInvestments = ({ userPortfolio = {} }) => {
  const investmentsInProgress = userPortfolio
    && userPortfolio.transactions
    && userPortfolio.transactions.filter((transaction) => !isTransactionComplete(transaction) && transaction?.amount);

  const syndicationProgramSignUpCompletedDate = getSyndicationProgramSignUpCompletedDate(userPortfolio);

  const withinWaitingPeriod = isWithinSyndicationProgramWaitingPeriod(syndicationProgramSignUpCompletedDate);

  const { hasMoiLevelProofOfAccreditation } = isUserEligibleToInvestInSyndication(userPortfolio);

  const showSyndicationProgram = userPortfolio
    && userPortfolio.syndicationProgramSignUpStartDate
   && !syndicationProgramSignUpCompletedDate
    && !hasMoiLevelProofOfAccreditation;

  return (
    <>
      {investmentsInProgress && investmentsInProgress.length > 0 && (
        <a className="topbar__nav-link" href={`${process.env.APP_AV_VC_PATH}/investment-summary`}>
          Investments in Progress
        </a>
      )}
      {showSyndicationProgram && (
        <a
          className="topbar__nav-link"
          href={`${process.env.APP_AV_VC_PATH}/syndicate-signup`}
        >
          Sign Up for Live Deals
        </a>
      )}
    </>
  );
};

TopbarNavInvestments.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  userPortfolio: PropTypes.any.isRequired,
};

export default TopbarNavInvestments;
